import { useTranslation } from "react-i18next";
import type { DateStyle } from "@/shared/utils/Dates.ts";
import { formatDate } from "@/shared/utils/Dates.ts";

interface DateFormatter {
  formatDate: (date: Date, style: DateStyle) => string;
}

export default function useDateFormatter(timeZone?: string): DateFormatter {
  const { i18n } = useTranslation();
  return {
    formatDate: (date: Date, style: DateStyle): string =>
      formatDate(date, i18n.language, style, timeZone),
  };
}
